import React from "react";
import styled from "styled-components";
import { Trans, useTranslation } from "react-i18next";
import { LinkContainer, Icon, IfPermitted, OverlayTrigger, PaginatedList, SearchForm } from "components/common";
import { Button, Col, Table, Row } from "components/bootstrap";
import QueryHelper from "components/common/QueryHelper";
import ForwarderRoutes from "forwarder/Routes";
import InputProfileEntry from "./InputProfileEntry";
import { StyledSearchFormWrapper, StyledToolbar } from "../wizard/StyledWizardComponents";
import { QueryHelpButton } from "../CommonStyledComponents";
const StyledTable = styled(Table)`
  .searchHelpButton {
    cursor: help;
    padding: 0 0 0 2px;
    margin-left: 5px;
  }

  .popoverWide {
    max-width: 500px;
    min-width: 350px;
  }

  th.rowActions {
    width: 180px;
  }

  tr > td {
    &.rowName {
      width: 35%;
    }

    &.rowDescription {
      max-width: 50%;
      width: 35%;
    }

    &.rowNumberForwarder {
      text-align: center;
    }
  }
`;
const QUERY_EXAMPLE_LOCAL = "local";
const QUERY_EXAMPLE_TITLE_LOCAL = "title:local";
const QUERY_EXAMPLE_TITLE_DATABASE = "title:database";
const QueryExamples = () => {
  const { t } = useTranslation("enterprise_forwarder");
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("p", null, t("input_profiles_list.find_by_title"), "\xA0", /* @__PURE__ */ React.createElement("kbd", null, QUERY_EXAMPLE_TITLE_LOCAL), "\xA0", /* @__PURE__ */ React.createElement("kbd", null, QUERY_EXAMPLE_TITLE_DATABASE)), /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(Trans, { t, i18nKey: "query_help.without_field_name", components: { code: /* @__PURE__ */ React.createElement("code", null) } }), " ", /* @__PURE__ */ React.createElement("kbd", null, QUERY_EXAMPLE_LOCAL), " ", t("query_help.is_the_same_as"), "\xA0", /* @__PURE__ */ React.createElement("kbd", null, QUERY_EXAMPLE_TITLE_LOCAL)));
};
const HelpPopover = () => /* @__PURE__ */ React.createElement(QueryHelper, { entityName: "Input Profile", example: /* @__PURE__ */ React.createElement(QueryExamples, null), commonFields: ["title", "description"] });
const InputProfilesListComponent = ({
  inputProfiles,
  forwarders,
  onForwardersAssign,
  pagination,
  onQueryChange,
  onInputProfileUpdate
}) => {
  const { t } = useTranslation("enterprise_forwarder");
  const { total, perPage, query } = pagination;
  const _getInputProfilesTable = () => inputProfiles.map((inputProfile) => {
    const forwarderCount = forwarders.filter((f) => f.input_profile_id === inputProfile.id).length;
    return /* @__PURE__ */ React.createElement(
      InputProfileEntry,
      {
        key: inputProfile.id,
        inputProfile,
        forwarderCount,
        onForwardersAssign,
        onInputProfileUpdate,
        forwarders
      }
    );
  });
  const _handleOnSearch = (nextQuery) => onQueryChange(1, 10, nextQuery);
  const _handleSearchReset = () => onQueryChange();
  const queryHelp = /* @__PURE__ */ React.createElement(OverlayTrigger, { trigger: "click", rootClose: true, placement: "right", overlay: /* @__PURE__ */ React.createElement(HelpPopover, null) }, /* @__PURE__ */ React.createElement(QueryHelpButton, { bsStyle: "link" }, /* @__PURE__ */ React.createElement(Icon, { name: "help" })));
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement("h2", null, t("input_profiles_list.heading"), " \xA0", /* @__PURE__ */ React.createElement("small", null, t("input_profiles_list.total", { total }))), /* @__PURE__ */ React.createElement(StyledSearchFormWrapper, null, /* @__PURE__ */ React.createElement(
    SearchForm,
    {
      query,
      queryHelpComponent: queryHelp,
      onSearch: _handleOnSearch,
      onReset: _handleSearchReset
    },
    /* @__PURE__ */ React.createElement(StyledToolbar, null, /* @__PURE__ */ React.createElement(IfPermitted, { permissions: "inputprofiles:create" }, /* @__PURE__ */ React.createElement(LinkContainer, { to: ForwarderRoutes.PROFILE.CREATE }, /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary" }, t("input_profiles_list.new_input_profile")))))
  )), /* @__PURE__ */ React.createElement(PaginatedList, { totalItems: total, pageSize: perPage, showPageSizeSelect: false }, /* @__PURE__ */ React.createElement(StyledTable, null, /* @__PURE__ */ React.createElement("thead", null, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", { className: "rowName" }, t("input_profiles_list.columns.title")), /* @__PURE__ */ React.createElement("th", { className: "rowDescription" }, t("input_profiles_list.columns.description")), /* @__PURE__ */ React.createElement("th", { className: "rowNumberForwarder" }, t("input_profiles_list.columns.assigned_to_forwarders")), /* @__PURE__ */ React.createElement("th", { className: "rowActions" }, t("input_profiles_list.columns.actions")))), /* @__PURE__ */ React.createElement("tbody", null, _getInputProfilesTable()))))));
};
export default InputProfilesListComponent;
